"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemDialog = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const SystemDialog = ({
  cancelLabel = 'Cancel',
  children,
  confirmLabel = 'Confirm',
  confirming = false,
  onCancel,
  onClose = onCancel,
  onConfirm,
  title
}) => {
  const titleId = (0, _react.useId)();
  const confirmRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    confirmRef.current?.focus();
    const handleKeyDown = event => {
      if (event.key === 'Escape' && !confirming) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [confirming, onClose]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "system-dialog-backdrop",
    role: "presentation",
    onMouseDown: event => {
      if (event.target === event.currentTarget && !confirming) {
        onClose();
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
      className: "system-dialog",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": titleId,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
        className: "system-dialog-header",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          id: titleId,
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          className: "system-dialog-close",
          type: "button",
          onClick: onClose,
          disabled: confirming,
          "aria-label": "Close dialog",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
            className: "bi bi-x-lg"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "system-dialog-body",
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("footer", {
        className: "system-dialog-footer",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          className: "btn bg-beige",
          type: "button",
          onClick: onCancel,
          disabled: confirming,
          children: cancelLabel
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          ref: confirmRef,
          className: "btn bg-green",
          type: "button",
          onClick: onConfirm,
          disabled: confirming,
          children: confirmLabel
        })]
      })]
    })
  });
};
exports.SystemDialog = SystemDialog;